import { Component, Input, Output, EventEmitter, OnInit, OnDestroy } from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { DataListFacilitationMeetingType } from "src/app/shared/models/data-list";
import { DisputeCaseBaseDto } from "src/app/shared/models/dispute-resolution/dispute-base-models";
import { DataListService } from "src/app/shared/services/data-list.service";
import {
  CreateUpdateIEPFacilitationMeetingDto,
  IEPFacilitationDisputeMeetingDto,
} from "src/app/shared/models/dispute-resolution/iep-facilitation-models";
import { AddEditMeetingInformationComponent } from "../add-edit-meeting-information/add-edit-meeting-information.component";
import { Subscription } from "rxjs";

@Component({
  selector: "app-meetings-list",
  templateUrl: "./meetings-list.component.html",
  styleUrls: ["./meetings-list.component.scss"],
  standalone: false,
})
export class MeetingsListComponent implements OnInit, OnDestroy {
  @Input() disputeCase: DisputeCaseBaseDto;
  @Input() meetings: CreateUpdateIEPFacilitationMeetingDto[] = [];
  @Output() meetingsChange = new EventEmitter<
    CreateUpdateIEPFacilitationMeetingDto[]
  >();

  displayedColumns: string[] = [
    "scheduledDate",
    "type",
    "meetingHappened",
    "actions",
  ];

  meetingTypeOptions: DataListFacilitationMeetingType[] = [];

  private subscriptions = new Subscription();

  constructor(
    private dataListService: DataListService,
    private dialog: MatDialog
  ) {}

  ngOnInit(): void {
    this.subscriptions.add(
      this.dataListService
        .getFacilitationMeetingTypes({
          pageIndex: 0,
          pageSize: 100,
        })
        .subscribe((meetingTypeOptions) => {
          this.meetingTypeOptions = meetingTypeOptions;
        })
    );
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }

  addMeeting() {
    const dialogRef = this.dialog.open(AddEditMeetingInformationComponent, {
      width: "1100px",
      data: {
        disputeCase: this.disputeCase,
        meeting: null,
        meetingTypeOptions: this.meetingTypeOptions,
      },
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.meetings = [...this.meetings, { ...result }];
        this.meetingsChange.emit(this.meetings);
      }
    });
  }

  editMeeting(meeting: IEPFacilitationDisputeMeetingDto) {
    const dialogRef = this.dialog.open(AddEditMeetingInformationComponent, {
      width: "1100px",
      data: {
        disputeCase: this.disputeCase,
        meeting: { ...meeting },
        meetingTypeOptions: this.meetingTypeOptions,
      },
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        if (!result.id) {
          // Editing a newly created meeting (no id): match by reference
          const idx = this.meetings.indexOf(meeting);
          if (idx !== -1) {
            this.meetings = this.meetings.map((p, i) =>
              i === idx ? { ...p, ...result } : p
            );
          }
        } else {
          // Editing an existing meeting (with id): match by id
          this.meetings = this.meetings.map((p) =>
            p.id && result.id && p.id === result.id ? { ...p, ...result } : p
          );
        }
        this.meetingsChange.emit(this.meetings);
      }
    });
  }
}
